import milestone1 from './milestone-1.png'
import milestone2 from './milestone-2.png'
import milestone3 from './milestone-3.png'
import milestone4 from './milestone-4.png'
import milestone5 from './milestone-5.png'

/** The five milestone rewards' images, hardcoded in milestone order
 *  (client-owned, see reward-visuals). */
export const milestoneRewardImages: string[] = [
  milestone1,
  milestone2,
  milestone3,
  milestone4,
  milestone5,
]

/** Client artwork for currency rewards with no nominal face — the bind
 *  reward and draw-converted deliveries (see lib/delivery.ts). Milestones
 *  1 and 3 are the coins (500) and gems (88) rewards. */
export const currencyArt = {
  coins: milestone1,
  gems: milestone3,
}
